<template>
    <div class="
      flex w-full flex-col overflow-auto bg-white

      lg:mb-0 lg:px-4 lg:pr-8 lg:pt-1

      sm:mb-[16px]
    "
        ref="wrapper"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'StepWrapper',

        mounted() {
            setTimeout(() => {
                const scrollContainer = this.$el.closest('.overflow-y-auto');
                if (scrollContainer) {
                    scrollContainer.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },
    };
</script>
